import React from 'react'

import { makeStyles, Grid, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationBlockProps } from '../../'
import compareBlockProps from '../../util/compareBlockProps'
import { InlineEditableHtml, InlineEditableMedia, InlineEditableText } from '../../inlineEditable'
import { usePresentation } from '../../../context'

const useStyles = makeStyles(
  (theme: Theme) => {
    return {
      root: {},
      title: {},
      content: {
        textAlign: 'center'
      },
      image: {
        '& img': {
          borderRadius: theme.spacing(1)
        }
      }
    }
  },
  { name: 'MissionBlock' }
)

function MissionBlock(props: PresentationBlockProps) {
  const classes = useStyles(props)
  const {
    isEditable,
    isSettings,
    presentationIndustry,
    presetColors,
    block,
    blockPrefix,
    setFieldValue,
    submitForm,
    WrapperComponent
  } = props
  const { presentationLibrary } = usePresentation()

  const { fields, title } = block

  const handleEditField = (field: string, content: any) => {
    setFieldValue(`${blockPrefix}.${field}`, content)
    submitForm()
  }

  const hasContent = fields?.content && !isHtmlEmpty(fields.content)

  return (
    <WrapperComponent {...props}>
      <Grid container spacing={3} direction={'column'} justifyContent={'center'} alignItems={'center'}>
        {(title || isEditable) && (
          <Grid item sm={12} md={8}>
            {isEditable ? (
              <InlineEditableText
                variant={'h2'}
                isSubmitOnEnter={true}
                handleEdit={(content) => handleEditField('title', content)}
                placeholderButtonText={'Add Title'}
                classes={{ root: classes.title }}
              >
                {title}
              </InlineEditableText>
            ) : (
              <Typography variant={'h2'} classes={{ root: classes.title }}>
                {title}
              </Typography>
            )}
          </Grid>
        )}
        {(hasContent || isEditable) && (
          <Grid item sm={12} md={8}>
            <InlineEditableHtml
              key={fields?.content}
              isEditable={isEditable}
              isSettings={isSettings}
              handleEdit={(content) => handleEditField('fields.content', content)}
              content={fields?.content}
              placeholderButtonText={'Add Text'}
              classes={{ root: classes.content }}
              presetColors={presetColors}
            />
          </Grid>
        )}
        {(fields?.image || isEditable) && (
          <Grid item sm={12} md={8}>
            <InlineEditableMedia
              classes={{ root: classes.image }}
              mediaOptionsProps={{
                blockPrefix: blockPrefix,
                fieldSuffix: 'image'
              }}
              presentationLibrary={presentationLibrary}
              file={fields?.image}
              handleEdit={(file) => handleEditField('fields.image', file)}
              isEditable={isEditable}
              isSettings={isSettings}
              placeholderButtonText={'Add Image'}
              presentationIndustry={presentationIndustry}
            />
          </Grid>
        )}
      </Grid>
    </WrapperComponent>
  )
}

export default React.memo(MissionBlock, (prevProps, nextProps) => {
  return compareBlockProps(prevProps, nextProps)
})
